import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconMountainBike: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMountainBike"><Path d="M19 15L16 4.5H13.5M6.5 6.5H9.5M10.9643 11.575L7.5 6.75M16.75 8.75L5 15" stroke="currentColor" strokeLinecap="square"/><Circle cx="19" cy="15" r="4.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="5" cy="15" r="4.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconMountainBike;
